/**
 * ant's Ant.Hardware.ProductFamily (GraphQL enum HardwareFamily, uppercase:
 * "KAYAK", "LAWN_GAME") as the console spells it. The one place the enum is
 * mapped; pages/support/tagGlossary.ts re-exports it with the glossary.
 */

export type HardwareFamily =
  | 'kayak'
  | 'life_jacket'
  | 'locker'
  | 'lawn_game'
  | 'scooter'
  | 'bike'
  | 'other';

export const HARDWARE_FAMILIES: HardwareFamily[] = [
  'kayak',
  'life_jacket',
  'locker',
  'lawn_game',
  'scooter',
  'bike',
  'other',
];

export const FAMILY_LABELS: Record<HardwareFamily, string> = {
  kayak: 'Kayak',
  life_jacket: 'Life jacket',
  locker: 'Locker',
  lawn_game: 'Lawn game',
  scooter: 'Scooter',
  bike: 'Bike',
  other: 'Other',
};

/** "KAYAK" to "kayak"; null for none or a value this console does not know. */
export function familyFromGraphql(
  value: string | null | undefined
): HardwareFamily | null {
  if (!value) return null;
  const lower = value.toLowerCase();
  return HARDWARE_FAMILIES.includes(lower as HardwareFamily)
    ? (lower as HardwareFamily)
    : null;
}

export function familyToGraphql(family: HardwareFamily): string {
  return family.toUpperCase();
}
